module.exports = __webpack_public_path__ + "static/JG1-cef0476d43d37fe1d3f0bdcb67192c4f.png";